import MockAdapter from 'axios-mock-adapter/types'

export function mockBars(mocker: MockAdapter) {
  mocker.onGet(RegExp('^/market/bars')).reply((config) => {
    return [
      200,
      {
        code: 200,
        data: {
          results: [],
        },
      },
    ]
  })
}
